"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTradeTPSLParams = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const TriggersApi_1 = require("../../../../apis/TriggersApi");
const interface_1 = require("../../../../interface");
const CalculateUtils_1 = require("../CalculateUtils");
const TPSLStore_1 = require("./TPSLStore");
const TPSLUtils_1 = require("./TPSLUtils");
const types_1 = require("./types");
const rxjs_1 = require("rxjs");
const CustomTriggersProvider_1 = require("../../../CustomOrders/CustomTriggersProvider");
const rx_1 = require("./../../../../component/CustomOrders/CustomTPSLProvider/rx");
function createNotify(orderId) {
    return (order) => {
        if (!!orderId) {
            // 通知更新
            (0, rx_1.dispatchOrderChangedEvent)({
                event: "update",
                ids: [orderId],
                orders: [Object.assign(Object.assign({}, order), { trigger_order_id: orderId })],
            });
        }
    };
}
/** 包裹一下Notify函数 */
function withNotify(ob, triggerId) {
    return ob.pipe((0, operators_1.tap)(createNotify(triggerId)));
}
// TODO: 待优化，和下面的createOrderTPSL函数抽成一个
function createTPSLOrder(params) {
    const { accountType, symbol, side, positionSide, orderId, triggerId, triggerPrice, priceType, amount, mode, type: _type, price, } = params;
    const type = _type || interface_1.CustomOrderType.MARKET_QTY;
    const request = {
        accountType,
        symbol,
        type,
        side,
        position_side: positionSide,
        trigger_order_id: orderId,
        trigger_trigger_id: triggerId,
        trigger_price: triggerPrice,
        trigger_price_type: priceType,
        trigger_type: TPSLUtils_1.TPSLUtils.getTriggerType(mode, positionSide),
        price,
    };
    if (amount) {
        request.amount = amount;
    }
    return withNotify((0, TriggersApi_1.createTriggerOrder)(request), orderId);
}
/**
 * 下单时设置止盈止损需要调用该hooks
 * take profit / stop loss TPSL
 */
function useTradeTPSLParams(props) {
    const { curPrice: oLatestPrice, mode, accountType, symbol, qty, price, orderType, investSide, precision, orderSide: originOrderSide, quoteDisplay, leverage, triggerPrice: _triggerPrice, triggerPriceType: _triggerPriceType, basePrecision = 2, markPrice: oMarkPrice, isPnlMode, isolateMode, estLiqPrice, closeMode: _closeMode, closeQty: _closeQty, currencyPrecision, avoidCompareLiqPrice, associateTrigger, orderId, triggerTriggerPrice = "", triggerLimitPrice: _triggerLimitPrice, } = props;
    // 下单时设置止盈止损时应与下单的方向相反
    const orderSide = originOrderSide === interface_1.CustomOrderSide.BUY ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY;
    const positionSide = CalculateUtils_1.CalculateUtils.getPositionSide(interface_1.OrderPositionMode.BUYSELL, true, orderSide);
    const isLimit = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType);
    const isTriggerOrder = !!triggerTriggerPrice;
    // 如果父订单是条件单，并且止盈止损为市价触发，则市价使用触发价格
    const latestPrice = isTriggerOrder ? triggerTriggerPrice : oLatestPrice;
    const markPrice = isTriggerOrder ? triggerTriggerPrice : oMarkPrice;
    // 下限价单时，需要采用用户输入的价格当做当前的价格
    const curPrice = isLimit ? price : latestPrice;
    // 计算真正的下单量(base)
    const positionQuantity = new trade_utils_lib_1.SafeDecimal(CalculateUtils_1.CalculateUtils.getTradeQty({
        qty,
        curPrice,
        price: curPrice,
        investSide,
        orderSide: originOrderSide,
        leverage,
    })).toFixed(basePrecision, decimal_js_1.default.ROUND_DOWN);
    const tradeQty = (0, react_1.useMemo)(() => new trade_utils_lib_1.SafeDecimal(positionQuantity).abs().toString(), [positionQuantity]);
    // 基于当前下单的参数，生成一个虚拟仓位，用于后续止盈止损相关的计算逻辑（useTpSlProviders）
    const position = (0, react_1.useMemo)(() => ({
        position_side: positionSide,
        leverage,
        avgPrice: curPrice,
        positionQuantity,
        currencyPrecision,
    }), [curPrice, currencyPrecision, leverage, positionQuantity, positionSide]);
    const providers = (0, TPSLUtils_1.useTpSlProviders)(position);
    // 下单时直接忽略预估强平价
    const store = (0, TPSLStore_1.useFuturesTPSLStore)(Object.assign({ latestPrice, limitPrice: price, mode, position_side: positionSide, quoteDisplay, maint_price: estLiqPrice || "", precision, trigger_price: _triggerPrice, trigger_limit_price: _triggerLimitPrice, trigger_price_type: _triggerPriceType, markPrice, scenes: isLimit ? TPSLStore_1.TPSLScene.TradeLimit : TPSLStore_1.TPSLScene.TradeMarket, isPnlMode,
        isolateMode, 
        // 修改下单默认平全部
        closeMode: _closeMode || types_1.TPSLCloseMode.CloseAll, closeQty: _closeQty, tradeQty,
        currencyPrecision,
        avoidCompareLiqPrice,
        symbol,
        leverage, 
        /**这里的type 先判断有没有订单，有订单的时候表示是编辑，走订单的type，没订单的时候判断限价价格存不存在，存在就是限价，不存在就走缓存 */
        type: (associateTrigger === null || associateTrigger === void 0 ? void 0 : associateTrigger.type) ? associateTrigger.type : _triggerLimitPrice ? interface_1.CustomOrderType.LIMIT : undefined }, providers));
    const { 
    // setPercent,
    // setTriggerPrice,
    setPriceType, triggerPrice, percent, priceType, profitInfo, checkUserModified, changePercent, changePrice, resetParams, latestPricePercent, closeToPriceWarning, profit, changeProfit, validateUserInput, validateWithLiqPrice, showSlLiquidPriceWarning, closeQty, setCloseQty, closeMode, setCloseMode, validateCloseSetting, closeSettingWarning, calcPnlQty, percentText, sliderValue, changePercentText, changeSidlerValue, scenes, triggerLimitPrice, changeTriggerLimitPrice, checkLimit, toggleCheckLimit, changePricePercent, pricePercent, } = store;
    const validate = (0, react_1.useCallback)((estLiqPrice) => {
        const error = validateCloseSetting();
        if (error) {
            return error;
        }
        return estLiqPrice ? validateWithLiqPrice(estLiqPrice) : profitInfo.error;
    }, [profitInfo.error, validateCloseSetting, validateWithLiqPrice]);
    const getCreateOrderParams = (0, react_1.useCallback)(({ orderId, triggerId }) => {
        const type = (0, TPSLUtils_1.getCreateTriggerOrderType)({ closeMode, checkLimit });
        const tradeParams = {
            accountType,
            symbol,
            type,
            side: positionSide === interface_1.FuturePositionSide.LONG ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY,
            position_side: positionSide,
            trigger_order_id: orderId,
            trigger_trigger_id: triggerId,
            trigger_price: triggerPrice,
            trigger_price_type: priceType,
            trigger_type: TPSLUtils_1.TPSLUtils.getTriggerType(mode, positionSide),
        };
        if (closeMode === types_1.TPSLCloseMode.CloseAmount) {
            // 获取当前下单的数量
            let amountD = new trade_utils_lib_1.SafeDecimal(positionQuantity).abs();
            tradeParams.amount = amountD.toString();
        }
        if (type === interface_1.CustomOrderType.LIMIT) {
            tradeParams.price = triggerLimitPrice;
        }
        return tradeParams;
    }, [accountType, checkLimit, closeMode, mode, positionQuantity, positionSide, priceType, symbol, triggerLimitPrice, triggerPrice]);
    /**设置订单止盈止损 */
    const createOrderTPSL = (0, react_1.useCallback)((params) => {
        const { orderId } = params;
        const tradeParams = getCreateOrderParams(params);
        return withNotify((0, TriggersApi_1.createTriggerOrder)(tradeParams), orderId);
    }, [getCreateOrderParams]);
    /**
     * 使用后端提供的接口来编辑条件单
     * https://pionex.atlassian.net/wiki/spaces/backend/pages/155844802/API#%E4%BF%AE%E6%94%B9%E6%9D%A1%E4%BB%B6%E5%8D%95
     */
    const editOrderTPSL = (0, react_1.useCallback)((trigger_id, params) => {
        const { accountType, symbol, type, price, amount, trigger_price, trigger_price_type } = getCreateOrderParams(params);
        return withNotify((0, TriggersApi_1.modifyTriggerOrder)({
            accountType,
            symbol,
            trigger_id,
            trigger_price,
            trigger_price_type,
            // TODO 这个地方应该让后端自动转为大写 @瑞松
            // 现在先前端转大写
            order_type: type.toUpperCase(),
            qty: amount,
            price,
        }), trigger_id);
    }, [getCreateOrderParams]);
    /**编辑模式，校验逻辑 */
    const editTPSLValidate = (0, react_1.useCallback)((estLiqPrice) => {
        const noop = {
            type: "IDLE",
            executor() {
                return (0, rxjs_1.of)(null);
            },
        };
        if (!orderId) {
            // 不存在订单id，说明不是编辑模式
            return (0, rxjs_1.of)(noop);
        }
        const error = validate(estLiqPrice);
        // 已经关联的条件单id
        const triggerId = associateTrigger === null || associateTrigger === void 0 ? void 0 : associateTrigger.trigger_id;
        if (error && error.code === TPSLUtils_1.TPSLErrorCode.INVALID_PRICE) {
            if (triggerId) {
                return (0, rxjs_1.of)({
                    type: "CANCEL_ORDER",
                    executor: () => (0, CustomTriggersProvider_1.cancelTriggerOrder)({
                        accountType,
                        symbol,
                        triggerId,
                    }),
                });
            }
            else {
                // 没有任何操作
                return (0, rxjs_1.of)(noop);
            }
        }
        const params = { [isTriggerOrder ? "triggerId" : "orderId"]: orderId };
        if (!error) {
            if (!checkUserModified()) {
                // 未发生变跟
                return (0, rxjs_1.of)(noop);
            }
            if (triggerId) {
                // 先取消订单，再重新下单
                return (0, rxjs_1.of)({
                    type: "UPDATE_ORDER",
                    executor: () => editOrderTPSL(triggerId, params),
                });
            }
            // 直接下单
            return (0, rxjs_1.of)({
                type: "CREATE_ORDER",
                executor: () => createOrderTPSL(params),
            });
        }
        return (0, rxjs_1.throwError)(() => error);
    }, [
        accountType,
        associateTrigger === null || associateTrigger === void 0 ? void 0 : associateTrigger.trigger_id,
        checkUserModified,
        createOrderTPSL,
        editOrderTPSL,
        isTriggerOrder,
        orderId,
        symbol,
        validate,
    ]);
    const createOrderTPSLWeb = (0, react_1.useCallback)((params) => {
        const { orderId, triggerPrice, priceType, qty, side: _side, closeMode, closeQty, triggerId, triggerLimitPrice } = params;
        function getOrderType() {
            if (triggerLimitPrice && new trade_utils_lib_1.SafeDecimal(triggerLimitPrice).gte(0)) {
                return interface_1.CustomOrderType.LIMIT;
            }
            return closeMode === types_1.TPSLCloseMode.CloseAll ? interface_1.CustomOrderType.CLOSE : interface_1.CustomOrderType.MARKET_QTY;
        }
        // 下单时设置止盈止损时应与下单的方向相反
        const orderSide = _side === interface_1.CustomOrderSide.BUY ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY;
        const positionSide = CalculateUtils_1.CalculateUtils.getPositionSide(interface_1.OrderPositionMode.BUYSELL, true, orderSide);
        const side = positionSide === interface_1.FuturePositionSide.LONG ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY;
        const allQty = CalculateUtils_1.CalculateUtils.getTradeQty({
            qty,
            curPrice,
            price: curPrice,
            investSide,
            orderSide: originOrderSide,
            leverage,
        });
        const type = getOrderType();
        const createParams = {
            accountType,
            symbol,
            side,
            positionSide,
            orderId,
            triggerId,
            triggerPrice,
            priceType,
            mode,
            type,
        };
        if (closeMode === types_1.TPSLCloseMode.CloseAmount) {
            let tradeQtyD = new trade_utils_lib_1.SafeDecimal(closeQty || allQty).abs();
            createParams.amount = tradeQtyD.toDP(basePrecision, decimal_js_1.default.ROUND_DOWN).toString();
        }
        if (type === interface_1.CustomOrderType.LIMIT) {
            createParams.price = triggerLimitPrice;
        }
        return createTPSLOrder(createParams);
    }, [accountType, basePrecision, curPrice, investSide, leverage, mode, originOrderSide, symbol]);
    return {
        changePercent,
        percent,
        changePrice,
        triggerPrice,
        estPnl: profitInfo,
        validate,
        latestPrice: curPrice,
        priceType,
        setPriceType,
        resetParams,
        latestPricePercent,
        checkUserModified,
        createOrderTPSL,
        showSlLiquidPriceWarning,
        closeToPriceWarning,
        profit,
        changeProfit,
        validateUserInput,
        createOrderTPSLWeb,
        closeQty,
        setCloseQty,
        closeMode,
        setCloseMode,
        validateCloseSetting,
        closeSettingWarning,
        calcPnlQty,
        percentText,
        sliderValue,
        changePercentText,
        changeSidlerValue,
        tradeQty,
        scenes,
        editTPSLValidate,
        triggerLimitPrice,
        changeTriggerLimitPrice,
        checkLimit,
        toggleCheckLimit,
        pricePercent,
        changePricePercent,
    };
}
exports.useTradeTPSLParams = useTradeTPSLParams;
